export const translateStatus = (booleanValue: boolean) =>
  booleanValue === true ? 'Active' : 'Inactive';
